import {
  SET_INCLUDE_HIDDEN_SITES,
  SET_INCLUDE_EMPTY_SITES,
  SET_DASHBOARD_FILTER,
} from "../actions/index";

export const initialState = {
  includeHiddenSites: false,
  // Sites without gateways are listed unless the user opts out.
  includeEmptySites: true,
  // Active dashboard site filters (WITH_ALARMS, WITH_ONLINE). Not persisted.
  dashboardFilters: [],
};

// includeHiddenSites and includeEmptySites are persisted to localStorage in store.js.
const generalSettings = (state = initialState, action) => {
  switch (action.type) {
    case SET_INCLUDE_HIDDEN_SITES:
      return {
        ...state,
        includeHiddenSites: action.payload,
      };
    case SET_INCLUDE_EMPTY_SITES:
      return {
        ...state,
        includeEmptySites: action.payload,
      };
    case SET_DASHBOARD_FILTER: {
      const { key, isSelected } = action.payload;
      const current = state.dashboardFilters ?? [];
      const isActive = current.includes(key);
      if (isSelected === isActive) return state;
      return {
        ...state,
        dashboardFilters: isSelected
          ? [...current, key]
          : current.filter((f) => f !== key),
      };
    }
    default:
      return state;
  }
};

export default generalSettings;
